import React, {
  createContext,
  useRef,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { message } from 'antd';

export const AlisaAudioManagerStateContext = createContext();
export const AlisaAudioManagerActionsContext = createContext();

export const AlisaAudioManagerProvider = ({ children }) => {
  const [playingShutdownId, setPlayingShutdownId] = useState(null);
  const ctxRef = useRef(null);
  const srcRef = useRef(null);

  const resetAudioContext = useCallback(() => {
    if (srcRef.current) {
      srcRef.current.disconnect();
      srcRef.current.stop();
      srcRef.current = null;
    }

    if (ctxRef.current) {
      ctxRef.current.close();
      ctxRef.current = null;
    }
  }, []);

  const onPlay = useCallback(
    ({ audioData, shutdownId }) => {
      resetAudioContext();

      if (!shutdownId) {
        setPlayingShutdownId(null);
      }

      if (audioData && shutdownId) {
        ctxRef.current = new (window.AudioContext ||
          window.webkitAudioContext)();

        ctxRef.current
          .decodeAudioData(audioData)
          .then((buffer) => {
            srcRef.current = ctxRef.current.createBufferSource();
            srcRef.current.buffer = buffer;
            srcRef.current.connect(ctxRef.current.destination);
            srcRef.current.start();
            srcRef.current.addEventListener('ended', () => {
              resetAudioContext();
              setPlayingShutdownId(null);
            });
            setPlayingShutdownId(shutdownId);
          })
          .catch((e) => {
            console.error('e', e);
            resetAudioContext();
            setPlayingShutdownId(null);
            message.error('Не удалось воспроизвести аудио');
          });
      }
    },
    [resetAudioContext]
  );

  const onStop = useCallback(() => {
    resetAudioContext();
    setPlayingShutdownId(null);
  }, [resetAudioContext]);

  const actions = useMemo(() => ({ onPlay, onStop }), [onPlay, onStop]);

  return (
    <AlisaAudioManagerStateContext.Provider value={playingShutdownId}>
      <AlisaAudioManagerActionsContext.Provider value={actions}>
        {children}
      </AlisaAudioManagerActionsContext.Provider>
    </AlisaAudioManagerStateContext.Provider>
  );
};
